<template>
    <GridImageWithName
        root-class="inspiration-list"
        :list="filterItems"
        :inside-redirect="false"
        :inside="true"
    />
</template>

<script>
import GridImageWithName from '~/components/common/GridImageWithName';

export default {
    name: 'CategoriesList',
    components: {
        GridImageWithName,
    },
    props: {
        list: {
            type: Array,
            required: true,
        },
    },
    computed: {
        filterItems() {
            return this.list.map((item) => {
                const { category: subName, ...dataForItem } = item;
                return { ...dataForItem, subName };
            });
        },
    },
};
</script>
